import { MetaTags } from '@components';
import { useEventfy, useLobbyQueries } from '@hooks';

import EventInfoCard from './EventInfoCard';
import BroadcastRoomsCarousel from './BroadcastRoomsCarousel';
import SpeakersSection from './SpeakersSection';
import VideosCarousel from './VideosCarousel';
import SponsorsSection from './SponsorsSection';
import LobbySidebar from './LobbySidebar';
import LobbyBannerCarousel from './LobbyBannerCarousel';
import * as S from './styles';

const Lobby = () => {
  const event = useEventfy();

  const queries = useLobbyQueries();
  const [roomsQuery, speakersQuery, scheduleQuery, sponsorsQuery, videosQuery] =
    queries;

  return (
    <S.Container>
      <S.MainContent>
        <MetaTags title="Lobby" />

        <LobbyBannerCarousel />

        <S.ContentWrapper>
          <EventInfoCard roomsQuery={roomsQuery} />

          {event.rooms > 1 && (
            <BroadcastRoomsCarousel roomsQuery={roomsQuery} />
          )}

          <VideosCarousel videosQuery={videosQuery} />

          <SpeakersSection speakersQuery={speakersQuery} />

          <SponsorsSection sponsorsQuery={sponsorsQuery} />
        </S.ContentWrapper>
      </S.MainContent>

      <S.Sidebar>
        <LobbySidebar scheduleQuery={scheduleQuery} />
      </S.Sidebar>
    </S.Container>
  );
};

export default Lobby;
